import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            className="location"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <span className="location-icon">📍</span>
            UK-BASED - NORTH WEST ENGLAND
          </motion.div>

          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            Strategic Websites & Digital Systems for Growing UK Businesses
          </motion.h1>

          <motion.h2
            className="hero-subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            North West Development Studio
          </motion.h2>

          <motion.p
            className="hero-description"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.8 }}
          >
            Leviathan Coding Systems is <Link to="/web-developer-widnes" className="hero-inline-link">based in Widnes</Link> and helps small and growing businesses strengthen their online presence, attract more customers, and streamline operations <span className="gradient-text">through tailored digital solutions that help businesses grow</span>. Learn more about <Link to="/digital-growth" className="hero-inline-link">how we help businesses grow</Link>.
          </motion.p>

          <motion.div
            className="hero-buttons"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.8 }}
          >
            <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })} className="btn-primary">
              Start a Project
            </button>
            <button onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth', block: 'start' })} className="btn-secondary">
              See What We Do
            </button>
          </motion.div>

          <motion.div
            className="hero-features"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.1, duration: 0.8 }}
          >
            <div className="feature-item">
              <span className="feature-label">UK-based</span>
              <span className="feature-value">North West England</span>
            </div>
            <div className="feature-item">
              <span className="feature-label">Bespoke builds</span>
              <span className="feature-value">No templates</span>
            </div>
            <div className="feature-item">
              <span className="feature-label">Designed for growth</span>
              <span className="feature-value">Built to scale</span>
            </div>
          </motion.div>
        </motion.div>

        <motion.div
          className="hero-image"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          <div className="dragon-container">
            <div className="dragon-glow"></div>
            <motion.div 
              className="dragon-image-wrapper"
              animate={{ 
                y: [0, -20, 0]
              }}
              transition={{
                duration: 6,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            >
              <picture>
                <source srcSet="/images/hero-image-2.webp" type="image/webp" />
                <img
                  src="/images/hero-image-2.png"
                  alt="Leviathan Dragon Logo"
                  className="dragon-image"
                  loading="eager"
                  decoding="async"
                  fetchPriority="high"
                  width="1576"
                  height="1928"
                />
              </picture>
            </motion.div>
          </div>
        </motion.div>

        <motion.div
          className="scroll-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 2, duration: 1 }}
        >
          <motion.div
            className="mouse-icon"
            animate={{ y: [0, 8, 0] }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            <div className="mouse-body">
              <motion.div
                className="mouse-wheel"
                animate={{ y: [0, 6, 0] }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              />
            </div>
          </motion.div>
          <span className="scroll-text">Scroll to explore</span>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
